import angular  from 'angular'
import uiRouter from 'angular-ui-router'

import component from './installation-guide.component'

let module = angular.module('installationGuide', [
  uiRouter
])

.component('installationGuide', component)

.name

export default module



// WEBPACK FOOTER //
// ./src/app/pages/installation/installation-guide/index.js